import type { DashboardOpsResponse } from "../types/dashboard";
import { fetchBilling } from "./billing-api";

export interface GroupStoreSalesRequest {
  groupname: string;
  date: string;
}

export interface GroupStoreSalesResponse {
  message: string;
  data: Record<string, unknown>[];
}

export interface DashboardGroupsResponse {
  message: string;
  data: { groupName: string }[];
}

// v2 groups list — GET /api/v1/dashboard/groups. Returns the groups the
// authenticated user can see; replaces deriving them from fetchShops.
export async function getDashboardGroups(): Promise<DashboardGroupsResponse> {
  return fetchBilling<DashboardGroupsResponse>("/dashboard/groups");
}

// v2 dashboard — GET /api/v1/dashboard?date=YYYY-MM-DD. Auth derives
// shopId from the session, so no body/customerId required. Replaces
// the legacy /mobile_backend/dashboard_preload_data preload endpoint.
export async function getDashboardOps(
  date?: string,
): Promise<DashboardOpsResponse> {
  const qs = date ? `?date=${encodeURIComponent(date)}` : "";
  return fetchBilling<DashboardOpsResponse>(`/dashboard${qs}`);
}

// v2 group sales — GET /api/v1/dashboard/group-sales?groupname&date.
// Pass-through to storealerts.fn_group_store_sales, same row shape as
// the legacy POST endpoint, so the row parser doesn't need to change.
export async function fetchGroupStoreSales(
  request: GroupStoreSalesRequest,
): Promise<GroupStoreSalesResponse> {
  const params = new URLSearchParams({
    groupname: request.groupname,
    date: request.date,
  });
  return fetchBilling<GroupStoreSalesResponse>(
    `/dashboard/group-sales?${params.toString()}`,
  );
}
